import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import Loadable from '@/components/Loadable'

const BlockedCpfs = Loadable(
  lazy(() => import('../pages/BlockedCpfs/BlockedCpfs.page')),
  true,
)

const PatientRoutes: RouteObject = {
  path: 'paciente',
  children: [
    {
      path: 'cpfs-bloqueados',
      element: <BlockedCpfs />,
    },
  ],
}

export default PatientRoutes
